/* eslint-disable react/prefer-es6-class, react/no-did-mount-set-state, react/sort-comp, no-unused-vars, react/jsx-first-prop-new-line, react/jsx-closing-bracket-location */
import classnames from 'classnames';
import React from 'react';
import ReactDOM from 'react-dom';
import Keys from 'es6/core/keys';
import FitText from 'es6/components/common/fit-text';
import HintButton from 'es6/components/apps/hint-button';
import { t } from 'es6/services/localization';
import { Navigation, NavButton, NavContainer } from 'es6/components/apps/navigation';
import QuizStatus from 'es6/components/apps/sentence-builder/quiz-status';
import * as SoundEffects from 'es6/core/sound-effects';
import SoundManager from 'es6/services/sound-manager';
import SoundPlayer from 'es6/components/common/sound-player';
import WordChoices from 'es6/components/apps/sentence-builder/word-choices';
import WordSlots from 'es6/components/apps/sentence-builder/word-slots';

const LARGE_DISPLAY_ROWS = 4;

export default React.createClass({
  displayName: 'SentenceBuilderQuizScreen',

  propTypes: {
    hints: React.PropTypes.number.isRequired,
    maxHints: React.PropTypes.number.isRequired,
    maxMistakes: React.PropTypes.number.isRequired,
    mistakes: React.PropTypes.number.isRequired,
    mode: React.PropTypes.oneOf(['listening', 'reading']).isRequired,
    onClick: React.PropTypes.func.isRequired,
    onDrop: React.PropTypes.func.isRequired,
    onDrag: React.PropTypes.func.isRequired,
    onDragEnd: React.PropTypes.func.isRequired,
    onDontKnow: React.PropTypes.func.isRequired,
    onHint: React.PropTypes.func.isRequired,
    onShift: React.PropTypes.func.isRequired,
    onSubmit: React.PropTypes.func.isRequired,
    sentence: React.PropTypes.object.isRequired,
    wordChoices: React.PropTypes.array.isRequired,
    wordSlots: React.PropTypes.array.isRequired,
  },

  getInitialState() {
    return {
      calculatedDisplaySize: false,
      focusNavigation: true,
      isLargeDisplay: false,
      allSlotsFilled: this._allSlotsFilled(this.props.wordSlots),
    };
  },

  /**
   * Determine if the sentence is taking up a lot of real estate. If so,
   * mark the state as being a large display.
   */
  componentDidMount() {
    const wordChoices = ReactDOM.findDOMNode(this.refs.wordChoices);
    const wordPieces = [...wordChoices.querySelectorAll('.word-piece')];
    const rows = wordPieces.map(wordPiece => wordPiece.offsetTop)
      .filter((offset, i, arr) => arr.indexOf(offset) === i)
      .length;

    this.setState({ calculatedDisplaySize: true, isLargeDisplay: rows >= LARGE_DISPLAY_ROWS });

    document.addEventListener('keydown', this._handleKeyDown);

    // If all the slots are filled and not marked as incorrect, focus the default navigation button.
    if (this.state.allSlotsFilled) {
      this.refs.navigation.focusDefaultButton();
    }
  },

  /**
   * Play and update mistakes if the number of mistakes changed.
   * Check to see if the navigation is focusable.
   *
   * @param {Object} nextProps
   */
  componentWillReceiveProps(nextProps) {
    const mistakes = nextProps.mistakes;

    if (typeof mistakes === 'number' && mistakes > this.props.mistakes) {
      SoundManager.playEffect(SoundEffects.SPELL_INCORRECT);
    }

    this.setState({
      allSlotsFilled: this._allSlotsFilled(nextProps.wordSlots),
    });
  },

  componentDidUpdate(prevProps, prevState) {
    // If all the slots are filled and not marked as incorrect, focus the default navigation button.
    if (this.state.allSlotsFilled && !prevState.allSlotsFilled) {
      this.refs.navigation.focusDefaultButton();
    }
  },

  componentWillUnmount() {
    document.removeEventListener('keydown', this._handleKeyDown);
  },

  _allSlotsFilled(wordSlots) {
    return wordSlots.every(slot => slot.isFilled() && !slot.isIncorrectAndGraded());
  },

  _handleKeyDown(e) {
    if (e.keyCode !== Keys.ENTER) {
      // TODO: Remove this and other blanket preventDefaults, because they also prevents browser
      // keyboard shortcuts, such as Ctrl-R to refresh.
      e.preventDefault();
    }

    if (this.props.mode === 'listening' && e.keyCode === Keys.SPACE) {
      SoundManager.play(this.props.sentence.sound);
    }

    if (e.keyCode === Keys.UP && e.shiftKey) {
      this.props.onHint();
    }
  },

  render() {
    const { hints,
           maxMistakes,
           maxHints,
           mistakes,
           mode,
           onClick,
           onDrop,
           wordChoices,
           wordSlots } = this.props;

    const { calculuatedSize, isLargeDisplay } = this.state;

    // If all the slots are filled and not marked as incorrect, make the navigation focusable.
    const focusNavigation = this.state.allSlotsFilled;

    // If the navigation is focusable, then the word choices are not focusable.
    const enableKeyEvents = !focusNavigation;

    // Hide the style if the display size hasn't been determined yet.
    const style = { visibility: calculuatedSize ? 'hidden' : 'visible' };

    const quizContentClassName = classnames('quiz-content', {
      'quiz-content-large-display': isLargeDisplay,
    });

    return (
      <div className="screen screen-sentence-builder-quiz">
        <div className="screen-content" style={style}>
          <QuizStatus mistakes={mistakes} maxMistakes={maxMistakes} />

          <header className="quiz-details message">{t('sentence-builder-quiz-instructions')}</header>

          <div className={quizContentClassName}>
            {mode === 'reading' ? this._renderReading() : this._renderListening()}

            <WordChoices ref="wordChoices" data={wordChoices} enableKeyEvents={enableKeyEvents} onClick={onClick} onDrop={onDrop} />
          </div>
        </div>

        <Navigation ref="navigation">
          <NavButton align="left" onClick={this.props.onDontKnow} focusable={focusNavigation} className="btn-danger">{t("don't know")}</NavButton>

          <NavContainer align="center">
            <HintButton hints={hints} maxHints={maxHints} onClick={this.props.onHint} />
          </NavContainer>

          <NavButton align="right" onClick={this.props.onSubmit} focused={focusNavigation} focusable={focusNavigation}>{t('enter')}</NavButton>
        </Navigation>
      </div>
    );
  },

  _renderReading() {
    const translation = this.props.sentence.getTranslation();

    return (
      <div className="quiz-content reading">
        <div ref="sentenceText" className="sentence-text">
          <FitText><span dangerouslySetInnerHTML={{ __html: translation }} /></FitText>
        </div>

        {this._renderWordSlots()}
      </div>
    );
  },

  _renderListening() {
    const sound = this.props.sentence.sound;

    return (
      <div className="quiz-content listening">
        <SoundPlayer source={sound} />
        {this._renderWordSlots()}
      </div>
    );
  },

  _renderWordSlots() {
    const { onClick,
          onDrag,
          onDragEnd,
          onDrop,
          onShift,
          wordSlots } = this.props;

    return (
      <WordSlots data={wordSlots}
        enableDragEvents
        onClick={onClick}
        onDrag={onDrag}
        onDragEnd={onDragEnd}
        onDrop={onDrop}
        onShift={onShift} />
    );
  },
});
